import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomerInformationForm from './CustomerInformationForm';
import deepExtend from 'deep-extend';
import { Customer } from '../../../propTypes';

export default class CustomerInformationContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    customer: Customer.isRequired,
    htmlId: PropTypes.string.isRequired
  };

  state = {
    customer: this.props.customer && deepExtend({}, this.props.customer),
    customerProfileChanges: false
  };

  updateCustomer = event => {
    this.setState({ customerProfileChanges: true });
    const field = event.target.name;
    const customer = this.state.customer;
    if (field.indexOf('.') !== -1) {
      const fieldType = field.split('.')[0];
      const targetedField = field.split('.')[1];
      const nestedField = field.split('.')[2];
      nestedField
        ? (customer[fieldType][targetedField][nestedField] = event.target.value)
        : (customer[fieldType][targetedField] = event.target.value);
    } else if (
      field === 'street' ||
      field === 'street2' ||
      field === 'postal' ||
      field === 'city' ||
      field === 'state' ||
      field === 'country'
    ) {
      customer.address[field] = event.target.value;
    } else if (
      field === 'doNotCall' ||
      field === 'doNotMail' ||
      field === 'doNotEmail'
    ) {
      customer.customerPreferences[field] = !customer.customerPreferences[
        field
      ];
    } else if (field === 'isCompany') {
      customer[field] = !customer[field];
      customer.companyName = '';
      customer.companyType = '';
    } else {
      customer[field] = event.target.value;
    }
    return this.setState({ customer });
  };

  saveUpdate = () => {
    this.props.actions.customer.updateCustomer(this.state.customer);
    // eslint-disable-next-line no-alert
    alert(
      'Customer info was just saved to the mock DB! Hit refresh and note that the data persists. Check /api/db.json to see the saved mock data.'
    );
  };

  abandonChanges = () => {
    // Revert changes to any input fields
    this.setState({ customer: deepExtend({}, this.props.customer) });
  };

  render() {
    const { htmlId } = this.props;
    return (
      <div id={htmlId}>
        <CustomerInformationForm
          htmlId="CustomerInformation__Form"
          customer={this.state.customer}
          saveUpdate={this.saveUpdate}
          cancelUpdate={this.abandonChanges}
          updateCustomer={this.updateCustomer}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/MockApiExamplePage/CustomerInformationContainer.js